import { module } from 'angular';
import { react2angular } from 'react2angular';

import { CreatePipeline } from './CreatePipeline';

export const CREATE_PIPELINE_COMPONENT = 'spinnaker.core.pipeline.config.createNew.component';
module(CREATE_PIPELINE_COMPONENT, [])
  .component('createPipeline', react2angular(CreatePipeline, ['application']));



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./app/scripts/modules/core/src/pipeline/config/createPipeline.component.ts